import React from "react";
import { PhoneCall, RotateCcw, Headphones, X, PhoneOff, MessageSquareText } from "lucide-react";

export const RetryCallCard = ({ retry, onRetry, onSwitch, onDismiss, busy }) => {
  if (!retry) return null;
  const toCallback = retry.mode === "browser";
  return (
    <div
      className="mb-4 rounded-2xl border border-amber-200 bg-amber-50 p-4 shadow-sm animate-in fade-in slide-in-from-top-2"
      data-testid="retry-call-card"
    >
      <div className="flex items-start gap-3">
        <div className="h-9 w-9 rounded-full bg-amber-100 text-amber-700 flex items-center justify-center shrink-0">
          <PhoneOff className="h-4 w-4" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="font-heading font-bold text-sm text-zinc-900">Call to {retry.number} didn&rsquo;t connect</div>
          <p className="text-xs text-zinc-600 mt-0.5 leading-relaxed" data-testid="retry-call-reason">
            {retry.reason || "The number couldn't be reached or didn't answer."} You were not charged for the call.
          </p>
          {retry.smsCost != null && (
            <p className="text-xs text-emerald-700 mt-1 flex items-center gap-1" data-testid="retry-call-sms-note">
              <MessageSquareText className="h-3.5 w-3.5" /> We texted them your name and number
              {retry.smsCost > 0 ? ` ($${retry.smsCost.toFixed(2)})` : ""}.
            </p>
          )}
        </div>
        <button
          onClick={onDismiss}
          data-testid="retry-call-dismiss"
          aria-label="Dismiss"
          className="h-7 w-7 rounded-full text-zinc-400 hover:text-zinc-700 flex items-center justify-center shrink-0"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
      <div className="grid grid-cols-2 gap-2 mt-3">
        <button
          onClick={onRetry}
          disabled={busy}
          data-testid="retry-call-again"
          className="h-11 rounded-full bg-primary text-white text-sm font-bold flex items-center justify-center gap-1.5 hover:opacity-90 active:scale-95 transition disabled:opacity-60"
        >
          <RotateCcw className="h-4 w-4" /> Try again
        </button>
        <button
          onClick={onSwitch}
          disabled={busy}
          data-testid="retry-call-switch"
          className="h-11 rounded-full bg-white border border-black/10 text-zinc-800 text-sm font-bold flex items-center justify-center gap-1.5 hover:border-primary/40 active:scale-95 transition disabled:opacity-60"
        >
          {toCallback ? <PhoneCall className="h-4 w-4" /> : <Headphones className="h-4 w-4" />}
          {toCallback ? "Ring my phone" : "Call from device"}
        </button>
      </div>
    </div>
  );
};
